module.exports = __webpack_public_path__ + "img/to-logo.200c0db8.png";